import StyledSvg from '@gef-ui/material-svg-shared/StyledSvg';
import * as React from 'react';
const SvgTravelFidelityLow = (props)=>{
    const id = React.useId();
    return /*#__PURE__*/ React.createElement(StyledSvg, {
        xmlns: "http://www.w3.org/2000/svg",
        width: 56,
        height: 56,
        fill: "none",
        viewBox: "0 0 56 56",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: `url(#travel-fidelity-low_svg__a-${id})`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#E4EFFA",
        d: "M28.004 52.942c14.16 0 25.639-11.225 25.639-25.072S42.163 2.798 28.003 2.798 2.366 14.023 2.366 27.87s11.48 25.072 25.639 25.072"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E0AA3F",
        d: "M31.04 33.295c.568 0 1.036-.497 1.036-1.12s-.46-1.121-1.036-1.121-1.036.497-1.036 1.12.46 1.12 1.036 1.12",
        opacity: 0.34
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E13632",
        d: "M18.478 28.497c3.173.505-6.118 4.149-6.27 3.013-.265-2.054-2.072-5.832-3.324-9.686-.326-1.01.896-2.887 1.146-2.382 2.733 5.453 6.763 8.786 8.448 9.055"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E13632",
        d: "M11.51 22.017a25 25 0 0 0 1.67 2.28c-.554.177-1.1.37-1.64.522-.478.143-.948.278-1.426.421a82 82 0 0 1-.919-2.5c.767-.252 1.541-.496 2.315-.723"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AB1F08",
        d: "M9.082 20.393c-.342.976.501 2.684 1.26 4.452.531 1.245 1.98 4.948 3.165 5.209 1.13.244 2.285.361 3.43.42-2.003.91-4.66 1.65-4.736 1.052-.265-2.053-2.072-5.831-3.324-9.686-.129-.412 0-.967.197-1.439z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#D30000",
        d: "M43.298 24.685c3.028-1.633 8.516-6.16 11.537-8.289 1.654-1.17 1.085-.362.956-.126-.114.193-9.897 9.307-16.448 13.952-2.163 1.531 2.611-4.805 3.955-5.537"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AB1F08",
        d: "M43.298 24.685c.933-.505 2.102-1.28 3.362-2.18a1.44 1.44 0 0 0 1.048-.277c.728-.556 3.362-2.744 3.673-2.912 1.268-.681 3.606-2.945 3.682-3.071 1.38-.943.865-.202.736.016-.114.194-9.898 9.307-16.448 13.953-2.163 1.531 2.611-4.805 3.955-5.538z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E13632",
        d: "M51.569 27.42c1.601 2.473-3.363 5.452-8.82 6.445-2.004.362-25.335 2.096-28.895 1.313-6.725-1.49-5.73-3.98-5.017-4.19 3.924-1.187 30.945-8.23 33.7-8.61 4.44-.613 7.34 2.433 9.032 5.041"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M51.64 27.529c1.6 2.474-3.37 5.461-8.828 6.454-2.004.362-25.336 2.096-28.895 1.313-2.14-.471-3.5-1.044-4.334-1.616-1.792-1.22 2.9 3.619 32.136-1.346 1.806-.303 6.46-1.574 8.174-2.483 2.49-1.32 1.739-2.322 1.739-2.322z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AB1F08",
        d: "M12.976 33.319c-1.655 1.363-5.116 2.01-5.055 2.39.06.378 7.104-1.38 9.434-1.835 1.738-.337-3.856-.993-4.387-.555z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E13632",
        d: "M12.057 34.446c-1.67.497-4.136 1.28-4.136 1.263-.061-.379 3.4-1.019 5.055-2.39.531-.438 6.125.21 4.387.547-.364.067-.85.176-1.404.294-.236.06-1.473-.437-3.902.286"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EDEAE6",
        d: "M22.008 37.863c.16 1.018-.334 1.969-1.108 2.12s-1.533-.555-1.7-1.573c-.16-1.019.334-1.97 1.116-2.12.774-.144 1.533.554 1.692 1.573"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EDEAE6",
        d: "M28.656 40.43c-2.656.513-5.085-.573-7.757-.446-.888.042-1.473-3.812-.585-3.695 2.057.286 6.725-.395 7.598-.572z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EDEAE6",
        d: "M20.095 36.357a.28.28 0 0 1 .213-.068c.205-.042.41-.017.607.05 2.247.11 6.193-.47 6.998-.622l.744 4.713c-2.657.513-5.085-.573-7.757-.446-.774.151-1.533-.556-1.7-1.574-.145-.917.25-1.784.895-2.053"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EDEAE6",
        d: "M20.095 36.357a.28.28 0 0 1 .213-.068c.205-.042.41-.017.607.05 2.247.11 6.193-.47 6.998-.622l.744 4.713c-2.657.513-5.085-.573-7.757-.446-.774.151-1.533-.556-1.7-1.574-.145-.917.25-1.784.895-2.053"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C7DDF1",
        d: "M20.127 36.497c.06-.05.129-.076.212-.068.205-.042.41-.016.607.05 2.247.11 6.194-.47 6.998-.622l.744 4.713c-2.656.513-5.085-.573-7.757-.446-.774.151-1.533-.556-1.7-1.574-.144-.917.25-1.784.895-2.053"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#50769A",
        d: "M20.134 36.521c.06-.05.13-.076.213-.067a1.15 1.15 0 0 1 .607.05c1.958.101 5.199-.328 6.535-.547a.5.5 0 0 0-.076.219.47.47 0 0 0-.288.177c-.873 1.068-2.24 1.556-3.378 2.196-.98.547-1.966 1.069-2.945 1.599-.729.059-1.42-.623-1.571-1.59-.144-.901.25-1.768.895-2.037z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M30.115 37.893c.205 1.304-.425 2.516-1.419 2.7-.987.194-1.958-.706-2.163-2.01-.205-1.305.425-2.508 1.42-2.702.986-.185 1.957.716 2.162 2.011"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#6E878E",
        d: "M29.834 37.951c.175 1.094-.364 2.12-1.191 2.28-.835.16-1.648-.597-1.822-1.69-.175-1.095.364-2.113 1.192-2.281.827-.169 1.647.589 1.821 1.691"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#213E47",
        d: "M28.977 38.111c.197 1.263-.638 2.214-1.086 2.02-.531-.227-.956-.842-1.07-1.599-.144-.9.266-1.7.478-1.86.327-.269 1.442-.033 1.678 1.44"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EDEAE6",
        d: "M22.357 34.875c-4.744 2.98-15.241 7.145-20.592 9.72C-1.157 46 .338 45.84.74 45.832c.342 0 20.357-6.631 31.962-12.185 3.84-1.843-8.243-.093-10.345 1.228"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E13632",
        d: "M22.357 34.875c-4.744 2.98-15.241 7.145-20.592 9.72C-1.157 46 .338 45.84.74 45.832c.342 0 20.357-6.631 31.962-12.185 3.84-1.843-8.243-.093-10.345 1.228"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AB1F08",
        d: "M29.523 34.509c.494-.261 2.133-2.037-8.075.9.303-.177.6-.353.872-.522 2.103-1.32 14.186-3.071 10.353-1.228-9.685 4.636-25.221 10.005-30.307 11.663 12.015-4.367 25.108-9.745 27.157-10.813M51.577 27.425s-1.745-1.32-5.106-3.203c-1.662-.933-2.192-1.635-16.988 1.803C16.741 28.984 8.218 31.18 8.92 30.97c3.875-1.177 30.806-8.597 33.533-8.967 4.388-.605 8.278 3.278 9.124 5.422"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F2F9FF",
        d: "M45.609 27.054c1.23-.328 2.565-1.01 2.96-1.43.387-.42.433-.682.463-1.397 0-.194-.98-.858-1.04-.766-.395.665-.767 1.086-.767 1.086s-1.427 1.27-2.861 1.994c-1.04.522.182.8 1.245.513"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M26.704 11.443h.1v-.052c0-1.856 2.285-3.359 5.107-3.359 2.392 0 4.39 1.082 4.95 2.54.085 0 .164-.008.25-.008 1.74 0 3.159.985 3.159 2.194s-1.412 2.194-3.16 2.194c-.952 0-1.804-.293-2.377-.751-.81.353-1.776.556-2.822.556q-.505 0-.989-.068c-.86.624-2.42 1.037-4.211 1.037-2.715 0-4.921-.962-4.921-2.141s2.206-2.142 4.92-2.142z"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: `travel-fidelity-low_svg__a-${id}`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h56v56H0z"
    }))));
};
export default SvgTravelFidelityLow;
